import * as React from 'react';
import { Counter, Cart, Button } from '@bepure/tarkin';
import { RegularProduct } from '@bepure/tarkin/dist/utils/cart';
import { useState } from 'react';
import Popup from 'components/Popup';

declare const RECHARGE_PRODUCT_DATA: any[];

interface Props {
    removeAllQuantityOfItem: () => void;
    onChangeHandler: (value: number) => void;
    product: RegularProduct;
    currency?: string;
    setContainsSubscription: Function;
    setCartLength : Function;
}

const ProductDiv = (props: Props) => {
    const isSubscriptionLogic = props.product.orderIntervalFrequency ? true : false;
    const [isSubscription, setIsSubscription] = useState(isSubscriptionLogic);
    const [popupOpen, setPopupOpen] = useState(false);
    const subscriptionFrequency = props.product.orderIntervalFrequency;
    const rechargeSubscriptionExists = !!RECHARGE_PRODUCT_DATA.find((x:any) => x.id == props.product.productId)?.subscriptions.length
    const interval_unit = rechargeSubscriptionExists ? RECHARGE_PRODUCT_DATA.find((x:any) => x.id == props.product.productId).subscriptions[0].order_interval_unit : "week"
    const discountedPrice = props.product.unit_price * 0.9;
    
    const upgradeHandler = async () => {
        setIsSubscription(true);
        const cart = Cart.getInstance();
        const cartItems = cart.getItems();
        const product: RegularProduct = {
            name: props.product.name,
            unit_price: props.product.unit_price,
            sku: props.product.sku,
            imageUrl: props.product.imageUrl,
            productId: props.product.productId,
            quantity: cartItems[props.product.productId]?.quantity || 1,
            variantId: props.product.variantId,
            chargeIntervalFrequecy: RECHARGE_PRODUCT_DATA.find((x:any) => x.id == props.product.productId).subscriptions[0].charge_interval_frequency || 4,
            orderIntervalFrequency: RECHARGE_PRODUCT_DATA.find((x:any) => x.id == props.product.productId).subscriptions[0].charge_interval_frequency || 4,
            orderIntervalUnit: rechargeSubscriptionExists ? RECHARGE_PRODUCT_DATA.find((x:any) => x.id == props.product.productId).subscriptions[0].order_interval_unit : "week"
        };
        props.setContainsSubscription(true);
        await cart.updateItem(product);
    }

    
    return (
        <div className="product-div">
            <div className="product-div__image-div">
                <img alt='product' src={props.product.imageUrl} height={70} width={150} />
            </div>
            <div className="product-div__detail-div">
                <div className="product-div__detail-div__title-div">
                    <div className="product-div__detail-div__text">
                        {props.product.name}
                    </div>
                    <div className="">
                        ${(props.product.unit_price * props.product.quantity).toFixed(2)} {props?.currency}
                    </div>
                </div>
                {/* subscription product */}
                {
                    isSubscription &&
                    <div className="product-div__detail-div__description-container">
                        <div>{"Subscription frequency every " + subscriptionFrequency + "-" + interval_unit + "s"}</div>
                        <div>{"You will be charged $" + discountedPrice.toFixed(2) + " " + props?.currency + " from next order."}</div>
                    </div>
                }
                {/* one off purchase */}
                {
                    !isSubscription &&
                    <div className="product-div__detail-div__description-container">
                        <div>One-off purchase</div>
                        {rechargeSubscriptionExists &&
                        <>
                            <span onClick={upgradeHandler}>Upgrade to Friend with Benefits for discounts and freebies. </span>
                            <a onClick={() => setPopupOpen(true)}>Learn more.</a>
                        </>
                        }
                    </div>
                }
                <div className="product-div__button-div">
                    <div className="product-div__button-div__counter-container">
                        <Counter
                            amount={props.product.quantity}
                            text={'Test'}
                            onChangeValue={props.onChangeHandler}
                        />
                    </div>
                    <div className="product-div__button-div__remove-item-div">
                        <button id={'product-remove_all_of_item'} className="product-div__button-div__remove-item-div__remove-item" onClick={props.removeAllQuantityOfItem}>
                            <i className="material-icons">&#xe5cd;</i>
                            <div className="product-div__button-div__remove-item-div__remove-item__text">Remove</div>
                        </button>
                    </div>
                </div>
            </div>
            <Popup 
                onClose={() => setPopupOpen(false)}
                open={popupOpen}
                imageSrc={{
                    desktopSrc: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Raster_Images/Friends+with+benefits/FWB_PopUp_Desktop_1064x535_150dpi.png',
                    mobileSrc: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Raster_Images/Friends+with+benefits/FWB_PopUp_Mobile_325x567_150dpi.png'
                }}
            >
                <>
                    <p>Read our <a href='/terms-and-conditions'>Terms & Conditions</a> for more information</p>
                    <Button 
                        ariaLabel={"learn more"}
                        text={'LEARN MORE'}
                        onClick={() => window.location.href = '/friends-benefits'}
                    />
                </>
            </Popup>
        </div>
    );
}

export default ProductDiv;
